module.exports = __webpack_public_path__ + "media/images/city_img/h_1-2b73c564374186c45b919bb89649ea1a.jpg";